import {Directive, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[calculateVirtualHeight]',
})
export class CalculateVirtualHeightDirective implements OnChanges {

    @Input() itemsQuantity: number = 0;
    @Input() itemOpenedHeightInPx: number = 0;
    @Input() itemHeightInPx: number = 0;
    @Input() openedItemsQuantity: number = 0;
    @Input() additionalHeightInPx: number = 0;
    @Input() maximumQuantityOfVisibleElements: number = 5;

    @Output() changeContainerHeight = new EventEmitter<void>();

    constructor(private el: ElementRef) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.itemsQuantity) {
            this.calculateVirtualHeight();
        }
    }

    /**
     * @description Calculates the size of the container given the number of all items and
     * height of one item and max size for the container.
     */
    calculateVirtualHeight(): void {
        if (!this.itemsQuantity || !this.itemHeightInPx) {
            throw new Error('Please set all required data for virtual scroll height calculation');
        }

        const maximumHeight = this.additionalHeightInPx + (this.maximumQuantityOfVisibleElements * this.itemHeightInPx);

        let virtualTableBodyHeight = 0;
        if (this.itemsQuantity === 0) {
            virtualTableBodyHeight = 0;
        } else if (this.itemsQuantity <= this.maximumQuantityOfVisibleElements) {
            const closedItemsQuantity = this.itemsQuantity - this.openedItemsQuantity;
            virtualTableBodyHeight = this.additionalHeightInPx + (closedItemsQuantity * this.itemHeightInPx) + 1;
            if (this.openedItemsQuantity) {
                virtualTableBodyHeight += this.openedItemsQuantity * this.itemOpenedHeightInPx;

                if (virtualTableBodyHeight > maximumHeight) {
                    virtualTableBodyHeight = maximumHeight;
                }
            }
        } else {
            virtualTableBodyHeight = maximumHeight;
        }

        this.el.nativeElement.style.height = virtualTableBodyHeight + 'px';
        this.changeContainerHeight.emit();
    }

}
